import type {StateCreator} from 'zustand'
import type {DiffFeature} from '@github-ui/diffs/types'

export type HiddenFeaturesSliceOpts = {
  hiddenFeatures: Set<DiffFeature>
}

export interface HiddenFeaturesSlice {
  hiddenFeatures: Set<DiffFeature>
}

export const createHiddenFeaturesSlice =
  ({hiddenFeatures}: HiddenFeaturesSliceOpts): StateCreator<HiddenFeaturesSlice, [['zustand/devtools', never]]> =>
  () => ({
    hiddenFeatures,
  })
